import { LineChart } from '@mantine/charts';
import { Loader, Center } from '@mantine/core';
import { useMemo } from 'react';

import { analyticsTypes } from '../../types';

type Props = {
  data: analyticsTypes.GetManagerRepliesResponse['data'];
  series: { name: string }[];
  isError: boolean;
  isLoading: boolean;
  isFetched: boolean;
};

const generateColor = () => {
  const colors = [
    'red',
    'pink',
    'grape',
    'violet',
    'indigo',
    'blue',
    'cyan',
    'teal',
    'green',
    'lime',
    'yellow',
    'orange',
  ];
  const shades = [3, 4, 5, 6, 7, 8, 9];
  const colorIndex = Math.floor(Math.random() * colors.length);
  const shadeIndex = Math.floor(Math.random() * shades.length);

  return `${colors[colorIndex]}.${shades[shadeIndex]}`;
};

export const ManagerRepliesChart = ({ data, series, isError, isLoading, isFetched }: Props) => {
  const seriesWithColor = useMemo(() => {
    return series.map((i) => ({ name: i.name, color: generateColor() }));
  }, [series]);

  if (isLoading) {
    return (
      <Center>
        <Loader m="xs" size="xl" />
      </Center>
    );
  }

  if (isError) {
    return <>'Error...'</>;
  }

  if (data.length === 0 && isFetched) {
    return <>'No data to show...'</>;
  }

  return (
    <LineChart
      h={400}
      data={data}
      dataKey="date"
      series={seriesWithColor}
      curveType="linear"
      withLegend
    />
  );
};
